import type { FC } from 'react';
import React, { useState } from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { capitalize } from 'lodash';
import { SORT_TYPES, ORDER_ASC } from '../../constants';

import { SortingModal } from './components/SortingModal';
import { SortTypeList } from './components/SortTypeList';

import type { Order } from '../../types';
import { ShowSortingButton } from './components/ShowSortingButton';
import { TEST_ID_SORT_CONTAINER } from './constants';

interface ISortingMobile {
  field: string;
  order?: Order;
  changeSorting({ field, order }: { field: string; order: Order }): void;
  className?: string;
}

export const SortingMobile: FC<ISortingMobile> = (props) => {
  const {
    className,
    field = 'price',
    order = ORDER_ASC,
    changeSorting,
  } = props;

  const [showModal, setShowModal] = useState(false);

  const changeSortingOrder = (id, type) => {
    changeSorting({
      field: id,
      order: type.order,
    });
    setShowModal(false);
  };

  const renderSortTypes = (currentType) =>
    SORT_TYPES.map(({ id, types }) => (
      <SortTypeList
        key={`${id}${currentType}`}
        id={id}
        types={types}
        currentType={currentType}
        onClick={changeSortingOrder}
      />
    ));

  const currentSort = SORT_TYPES.find((sort) => sort.id === field);
  const currentSortTypes = currentSort?.types;
  const currentType =
    currentSortTypes?.find((type) => type.order === order) ||
    currentSortTypes?.[0];

  const { t } = useTranslation();

  return (
    <div className={className} data-testid={TEST_ID_SORT_CONTAINER}>
      <ShowSortingButton onClick={() => setShowModal(true)}>
        {capitalize(currentSort?.label)}
      </ShowSortingButton>
      <SortingModal
        visible={showModal}
        onBackgroundClick={() => setShowModal(false)}
      >
        <Title>{t('search.sorting.label')}</Title>
        {renderSortTypes(currentType)}
      </SortingModal>
    </div>
  );
};

const Title = styled.div`
  margin: 8px 0 8px 8px;

  color: #17181a;
  font-size: 22px;
  font-weight: 700;
  line-height: 26px;
`;
